
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paymasters",
      function () {
        return require("private-next-pages/paymasters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paymasters"])
      });
    }
  